import React, { useCallback, useMemo, useState } from 'react'
import { useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';

import authContext from '../context/authContext/authContext';
import { getPartnersAction } from '../redux/actions/partnersAction';
import { getProductsAction, getSelectedProductsAction, selectProductAction } from '../redux/actions/productsAction';
import Loader from '../utils/Loader';
import SelectProductModal from '../components/modals/SelectProductModal';

const productEffect = "zoom-in-right";
const subProductEffect = 'zoom-in-down';


const getButtonLabel = (type, tokens, selected) => {
  if (selected) {
    return (
      <span style={{ position: 'relative', top: 3 }}>
        {tokens}
        <span style={{ zoom: 0.08, position: 'relative', left: 100, bottom: 75 }}>
          <img src="assets/img/gt-logo.png" />
        </span>
      </span>
    )
  }

  return (
    <span style={{ position: 'relative', top: 3 }}>
      Get {tokens}
      <span style={{ zoom: 0.08, position: 'relative', left: 100, bottom: 75 }}>
        <img src="assets/img/gt-logo.png" />
      </span>
    </span>
  )

}

const getStatus = (type, selected) => {
  if (type === 'product' || !selected) {
    return ''
  }

  const { status } = selected;
  if (status === 'pending') {
    return <span className='text-primary'><i className='fa fa-exclamation-circle mr-1' />Pending</span>
  }

  if (status === 'approved') {
    return <span className='text-success'><i className='fa fa-check mr-1' />Earned</span>
  }

  if (status === 'rejected') {
    return <span className='text-danger'><i className='fa fa-times mr-1' />Rejected</span>
  }
}

const RenderProduct = ({ selectedProducts, selectedProductsArray, product, selectButton, effect, delay, selectedProductId }) => {
  const navigate = useNavigate();
  const { _id, title, slogan, description, descriptiontyle, type, tokens } = product;
  const selected = selectedProducts.find((p) => p.productId === _id)
  return (
    <div class={`card mb-2 product ${selectedProductId === _id ? 'selected' : ''}`} key={_id} data-aos={effect} data-aos-delay={delay || "500"}>
      <h5 class="card-header text-black bg-white fw-600">{title}</h5>
      <div class="card-body">
        <h5 class="card-title">{slogan}</h5>
        <p class="fs-12" style={descriptiontyle}>{description}</p>
        <div class="fw-500" style={{ fontSize: 12 }}> {getStatus(type, selected)}</div>
        {type === 'product' ? (
          <div className='product-action-buttons'>
            <button class={`btn btn-gleamdesk fw-600 ${selected ? 'product-selected' : ''}`} disabled={selected} onClick={() => selectButton?.(_id)}>
              Explore
            </button>
          </div>
        ) : (
          <div className='sub-product-action-buttons d-flex justify-content-center flex-wrap gap-1'>
            <button to="/appointments" className={`btn btn-gleamdesk-blue fw-600 ${selected ? 'product-selected' : ''}`} style={{ minWidth: 75 }} disabled={selected} onClick={() => navigate('/appointments')}>
              Consult
            </button>
            <button className={`btn btn-gleamdesk fw-600 ${selected ? 'product-selected' : ''}`} style={{ minWidth: 100 }} disabled={selected} onClick={() => selectButton?.(_id)}>
              {getButtonLabel(type, tokens, selected)}
            </button>
          </div>
        )}
      </div>
    </div>
  )
}


const Products = () => {
  const { loading, products = [], selectedProducts } = useSelector((state) => state.products);
  const intialState = { tab: '' }
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { getConfig, user, setUser } = useContext(authContext);
  const config = getConfig();
  const [state, setCompleteState] = useState(intialState)
  const setState = (newState) => setCompleteState((prevState) => ({ ...prevState, ...newState }))

  const getProducts = () => {
    dispatch(getProductsAction(config))
  }

  const getSelectedProducts = () => {
    dispatch(getSelectedProductsAction(config))
  }

  useEffect(() => {
    getProducts();
    getSelectedProducts();
  }, [])

  const selectButton = (id) => {
    let productId = id;
    if (state.productId === id) {
      productId = '';
    }

    setState({ productId })
  }

  const getProductTitle = (id) => {
    const product = products.find(item => item._id === state.productId);
    return product?.title || '';
  }

  const subProducts = useMemo(() => {
    if (state.productId) {
      const product = products.find(item => item._id === state.productId);
      return product?.subProducts || [];
    }

  }, [state.productId, JSON.stringify(products)])

  const selectProductModal = (productId) => {
    const data = { productId }
    setState({ selectedProductId: productId, showSelectProductModal: true })
  }

  const selectProduct = (data, callback) => {
    dispatch(selectProductAction(config, data, getProducts, getSelectedProducts, callback))
  }

  const selectedProductsArray = selectedProducts.map((p) => p.productId)
  return (
    <>
      <div className='container mt-5'>
        <div className='px-2 px-md-4 px-lg-5 py-4'>
          <div className='section-title'>
            <p>Products</p>
            <div className=''>Gleamdesk offers trusted financial products including investments, FDs, insurance and many more wealth solutions designed to help you grow safely and achieve long-term goals.</div>

            <div className='mt-2'>
              <Loader isLoading={loading} />
            </div>
            <div className='row products mt-5 '>
              {products.map((product, i) => {
                return (
                  <RenderProduct
                    product={product}
                    // effect={productEffect}
                    delay={(i + 1) * 100}
                    selectedProductsArray={selectedProductsArray}
                    selectedProducts={selectedProducts}
                    selectedProductId={state.productId}
                    selectButton={selectButton}
                  />
                )
              })}
            </div>

            {state.productId && (
              <div>
                <div className='mt-4 mb-3 fw-600' style={{ fontSize: 20 }}>{getProductTitle()}</div>
                <div className='row products mt-1 justify-content-center'>
                  {subProducts.map((product, i) => {
                    return (
                      <RenderProduct
                        product={product}
                        effect={subProductEffect}
                        delay={(i + 1) * 100}
                        selectedProductsArray={selectedProductsArray}
                        selectedProducts={selectedProducts}
                        selectedProductId={state.productId}
                        selectButton={selectProductModal}
                      />
                    )
                  })}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      <SelectProductModal
        isOpen={state.showSelectProductModal}
        toggle={() => setState({ showSelectProductModal: false, selectedProductId: '' })}
        selectedProductId={state.selectedProductId}
        products={products}
        selectProduct={selectProduct}
      />
    </>
  )
}

export default Products